/* eslint-disable indent */
/* eslint-disable prettier/prettier */
import { ObjectId } from 'bson';
import { _BaseModel } from './helpers/_BaseModel';
_BaseModel.addDictionary({modelName:'Activity',dictionary:{"de":{"references":{"type":"Art","category":"Kategorie"},"general":{"name":"Name","description":"Beschreibung"},"activityId":"Tätigkeit-ID"},"en":{"references":{"type":"Type","category":"Kategorie"},"general":{"name":"Name","description":"Description"},"activityId":"Activity-ID"}}})
import { Login } from './Login';
import { ActivityType } from './ActivityType';
import { ActivityCategory } from './ActivityCategory';

export class Activity extends _BaseModel {
	
	static toString() {
		return 'Activity'
	}
	
	static get paths() {
		return 			{
			meta: 				{
					
	locked:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.Activity.meta.locked'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'Activity', path:'meta.locked'}) ],
},
    
	},
	
					
	createdAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Activity.meta.createdAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Activity', path:'meta.createdAt'}) ],
},
    
	},
	
					
	updatedAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Activity.meta.updatedAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Activity', path:'meta.updatedAt'}) ],
},
    
	},
	
					
	createdBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'Activity', path:'meta.createdBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	updatedBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'Activity', path:'meta.updatedBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	archived:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.Activity.meta.archived'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'Activity', path:'meta.archived'}) ],
},
    
	},
	
					
	currentDocument:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Activity'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Activity) || _BaseModel.t('rules.reference', {modelName:'Activity', path:'meta.currentDocument'}) ],
				model: Activity,
				returnObject: true,
},
    
	},
	
					
	revisions:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models._Revision'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'Activity', path:'meta.revisions'}) ],
				model: Activity,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
			references: 				{
					
	type:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.ActivityType'),
				itemText: "general.name",
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'Activity', path:'references.type'}),(value) => (value === undefined || value === null || typeof value === 'string' || value instanceof ActivityType) || _BaseModel.t('rules.reference', {modelName:'Activity', path:'references.type'}) ],
				model: ActivityType,
				returnObject: true,
},
    
	},
	
					
	category:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.ActivityCategory'),
				itemText: "general.name",
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'Activity', path:'references.category'}),(value) => (value === undefined || value === null || typeof value === 'string' || value instanceof ActivityCategory) || _BaseModel.t('rules.reference', {modelName:'Activity', path:'references.category'}) ],
				model: ActivityCategory,
				returnObject: true,
},
    
	},
	
},
			general: 				{
					
	name:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Activity.general.name'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'Activity', path:'general.name'}),(value)=> ( typeof value === 'string' && value.length > 0) || _BaseModel.t('rules.type.string', {modelName:'Activity', path:'general.name'}) ],
},
    
	},
	
					
	description:{
		type: 'string',
		__component: 'v-textarea',
    
		__bind: {				label: _BaseModel.t('models.Activity.general.description'),
				rows: 1,
				autoGrow: true,
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Activity', path:'general.description'}) ],
},
    
	},
	
},
				
	activityId:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Activity.activityId'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'Activity', path:'activityId'}),(value)=> ( typeof value === 'string' && value.length > 0) || _BaseModel.t('rules.type.string', {modelName:'Activity', path:'activityId'}) ],
},
    
	},
	
				
	_id:{
		type: 'objectId',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Activity._id'),
				rules: [  ],
},
    
	},
	
}
	}
	constructor({meta={}, references={}, general={}, activityId='', _id=new ObjectId(), }={}){
		super();
		this.meta=MetaClass.create(meta);
		this.references=ReferencesClass.create(references);
		this.general=GeneralClass.create(general);
		this.activityId=activityId;
		this._id=_id;
	}

	static create(data) {
		return new Activity(data);
	}
}

class MetaClass {
	constructor({locked=false, createdAt=undefined, updatedAt=undefined, createdBy=undefined, updatedBy=undefined, archived=false, currentDocument=undefined, revisions=[], __errors=[], }={}){
		this.locked=locked;
		this.createdAt=createdAt;
		this.updatedAt=updatedAt;
		this.createdBy= (createdBy instanceof Login || typeof createdBy === 'string' || !createdBy) ? createdBy : Login.create(createdBy);
		this.updatedBy= (updatedBy instanceof Login || typeof updatedBy === 'string' || !updatedBy) ? updatedBy : Login.create(updatedBy);
		this.archived=archived;
		this.currentDocument= (currentDocument instanceof Activity || typeof currentDocument === 'string' || !currentDocument) ? currentDocument : Activity.create(currentDocument);
		if(Array.isArray(revisions)){
			this.revisions=[];
			for(const item of revisions){
				if(typeof item === 'string') this.revisions.push(item)
				else if(typeof item === 'object')
					this.revisions.push(item instanceof Activity ? item : Activity.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.revisions=revisions;
		}
		this.__errors=__errors;
	}

	static create(data) {
		return new MetaClass(data);
	}
}

class ReferencesClass {
	constructor({type=undefined, category=undefined, }={}){
		this.type= (type instanceof ActivityType || typeof type === 'string' || !type) ? type : ActivityType.create(type);
		this.category= (category instanceof ActivityCategory || typeof category === 'string' || !category) ? category : ActivityCategory.create(category);
	}

	static create(data) {
		return new ReferencesClass(data);
	}
}

class GeneralClass {
	constructor({name='', description='', }={}){
		this.name=name;
		this.description=description;
	}

	static create(data) {
		return new GeneralClass(data);
	}
}
